(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const params = new URLSearchParams(window.location.search);
    const rawHandle = params.get('product') || '';
    const productHandle = /^[a-z0-9][a-z0-9-]{0,199}$/.test(rawHandle) ? rawHandle : '';

    if (productHandle) {
      const productLabels = {
        'audi-q3-sportback-f3-v1-carbon-frp-body-kit': 'Audi Q3 Sportback F3 V1 Body Kit',
        'audi-q3-sportback-f3-v2-widebody-carbon-frp-body-kit': 'Audi Q3 Sportback F3 V2 Widebody Kit',
        'dryzane-aero-da-01-monoblock-gt-wheels': 'Dryzane Aero DA-01 Monoblock GT Wheels',
        'dryzane-aero-da-02-split-five-wheels': 'Dryzane Aero DA-02 Split Five Wheels',
        'dryzane-aero-da-03-turbine-wheels': 'Dryzane Aero DA-03 Turbine Wheels',
        'dryzane-aero-da-04-mesh-rs-wheels': 'Dryzane Aero DA-04 Mesh RS Wheels',
        'dryzane-aero-da-05-aerodisc-wheels': 'Dryzane Aero DA-05 AeroDisc Wheels',
        'custom-signature-build': 'Custom Dryzane Aero Signature Build',
      };
      const normalizedProduct =
        productLabels[productHandle] ||
        productHandle.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

      document.querySelectorAll('[data-product-interest]').forEach((field) => {
        if (!field.value) field.value = normalizedProduct;
        field.form?.querySelectorAll('[data-product-handle]').forEach((hidden) => {
          hidden.value = field.value === normalizedProduct ? productHandle : '';
        });
      });

      document.querySelectorAll('[data-selected-product]').forEach((label) => {
        label.textContent = document.querySelector('[data-product-interest]')?.value || normalizedProduct;
      });
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = [...document.querySelectorAll('[data-dryzane-video]:not([data-viewport])')];

    if (reduceMotion) {
      videos.forEach((video) => video.pause());
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: '160px 0px', threshold: 0.15 }
      );

      videos.forEach((video) => observer.observe(video));
    }
  });
})();
